import _definePage_default_0 from '/var/www/html/resources/js/pages/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/var/www/html/resources/js/pages/forgot-password.vue?definePage&vue'
import _definePage_default_3 from '/var/www/html/resources/js/pages/history/containers/index.vue?definePage&vue'
import _definePage_default_4 from '/var/www/html/resources/js/pages/history/containers/[containerId].vue?definePage&vue'
import _definePage_default_5 from '/var/www/html/resources/js/pages/history/customers/index.vue?definePage&vue'
import _definePage_default_6 from '/var/www/html/resources/js/pages/history/customers/[customerId].vue?definePage&vue'
import _definePage_default_7 from '/var/www/html/resources/js/pages/history/reports/index.vue?definePage&vue'
import _definePage_default_8 from '/var/www/html/resources/js/pages/login.vue?definePage&vue'
import _definePage_default_9 from '/var/www/html/resources/js/pages/not-authorized.vue?definePage&vue'
import _definePage_default_10 from '/var/www/html/resources/js/pages/register.vue?definePage&vue'
import _definePage_default_11 from '/var/www/html/resources/js/pages/shipment/admin/conversations.vue?definePage&vue'
import _definePage_default_12 from '/var/www/html/resources/js/pages/shipment/claim-parcel.vue?definePage&vue'
import _definePage_default_13 from '/var/www/html/resources/js/pages/shipment/container-arrivals/index.vue?definePage&vue'
import _definePage_default_14 from '/var/www/html/resources/js/pages/shipment/customers/identification-queue.vue?definePage&vue'
import _definePage_default_15 from '/var/www/html/resources/js/pages/shipment/inbox.vue?definePage&vue'
import _definePage_default_16 from '/var/www/html/resources/js/pages/shipment/incoming-parcels/index.vue?definePage&vue'
import _definePage_default_17 from '/var/www/html/resources/js/pages/shipment/incoming-parcels/[id].vue?definePage&vue'
import _definePage_default_18 from '/var/www/html/resources/js/pages/shipment/outgoing-packages/index.vue?definePage&vue'
import _definePage_default_19 from '/var/www/html/resources/js/pages/shipment/packing-lists/index.vue?definePage&vue'
import _definePage_default_20 from '/var/www/html/resources/js/pages/shipment/packing-lists/[id]/view.vue?definePage&vue'
import _definePage_default_21 from '/var/www/html/resources/js/pages/shipment/partner-shipments/index.vue?definePage&vue'
import _definePage_default_22 from '/var/www/html/resources/js/pages/shipment/pending-imports.vue?definePage&vue'
import _definePage_default_23 from '/var/www/html/resources/js/pages/shipment/settings/index.vue?definePage&vue'
import _definePage_default_24 from '/var/www/html/resources/js/pages/shipment/warehouse/arrange-parcels/[containerId].vue?definePage&vue'
import _definePage_default_25 from '/var/www/html/resources/js/pages/shipment/warehouse/client-groups/[containerId].vue?definePage&vue'
import _definePage_default_26 from '/var/www/html/resources/js/pages/shipment/warehouse/cotation/index.vue?definePage&vue'
import _definePage_default_27 from '/var/www/html/resources/js/pages/shipment/warehouse/cotation/[containerId].vue?definePage&vue'
import _definePage_default_28 from '/var/www/html/resources/js/pages/shipment/warehouse/invoices/index.vue?definePage&vue'
import _definePage_default_29 from '/var/www/html/resources/js/pages/shipment/warehouse/invoices/[invoiceId].vue?definePage&vue'
import _definePage_default_30 from '/var/www/html/resources/js/pages/shipment/warehouse/pl-files/index.vue?definePage&vue'
import _definePage_default_31 from '/var/www/html/resources/js/pages/shipment/warehouse/pl-files/[containerId].vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/var/www/html/resources/js/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  {
    path: '/admin',
    /* internal name: 'admin' */
    /* no component */
    children: [
      {
        path: 'teams',
        /* internal name: 'admin-teams' */
        /* no component */
        children: [
          {
            path: '',
            name: 'admin-teams',
            component: () => import('/var/www/html/resources/js/pages/admin/teams/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('/var/www/html/resources/js/pages/forgot-password.vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  {
    path: '/history',
    /* internal name: 'history' */
    /* no component */
    children: [
      {
        path: 'containers',
        /* internal name: 'history-containers' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'history-containers',
            component: () => import('/var/www/html/resources/js/pages/history/containers/index.vue'),
            /* no children */
          },
  _definePage_default_3
  ),
  _mergeRouteRecord(
          {
            path: ':containerId',
            name: 'history-containers-container-id',
            component: () => import('/var/www/html/resources/js/pages/history/containers/[containerId].vue'),
            /* no children */
          },
  _definePage_default_4
  )
        ],
      },
      {
        path: 'customers',
        /* internal name: 'history-customers' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'history-customers',
            component: () => import('/var/www/html/resources/js/pages/history/customers/index.vue'),
            /* no children */
          },
  _definePage_default_5
  ),
  _mergeRouteRecord(
          {
            path: ':customerId',
            name: 'history-customers-customer-id',
            component: () => import('/var/www/html/resources/js/pages/history/customers/[customerId].vue'),
            /* no children */
          },
  _definePage_default_6
  )
        ],
      },
      {
        path: 'reports',
        /* internal name: 'history-reports' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'history-reports',
            component: () => import('/var/www/html/resources/js/pages/history/reports/index.vue'),
            /* no children */
          },
  _definePage_default_7
  )
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/var/www/html/resources/js/pages/login.vue'),
    /* no children */
  },
  _definePage_default_8
  ),
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('/var/www/html/resources/js/pages/not-authorized.vue'),
    /* no children */
  },
  _definePage_default_9
  ),
  _mergeRouteRecord(
  {
    path: '/register',
    name: 'register',
    component: () => import('/var/www/html/resources/js/pages/register.vue'),
    /* no children */
  },
  _definePage_default_10
  ),
  {
    path: '/shipment',
    /* internal name: 'shipment' */
    /* no component */
    children: [
      {
        path: 'admin',
        /* internal name: 'shipment-admin' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'conversations',
            name: 'shipment-admin-conversations',
            component: () => import('/var/www/html/resources/js/pages/shipment/admin/conversations.vue'),
            /* no children */
          },
  _definePage_default_11
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'claim-parcel',
        name: 'shipment-claim-parcel',
        component: () => import('/var/www/html/resources/js/pages/shipment/claim-parcel.vue'),
        /* no children */
      },
  _definePage_default_12
  ),
      {
        path: 'container-arrivals',
        /* internal name: 'shipment-container-arrivals' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'shipment-container-arrivals',
            component: () => import('/var/www/html/resources/js/pages/shipment/container-arrivals/index.vue'),
            /* no children */
          },
  _definePage_default_13
  )
        ],
      },
      {
        path: 'customers',
        /* internal name: 'shipment-customers' */
        /* no component */
        children: [
          {
            path: '',
            name: 'shipment-customers',
            component: () => import('/var/www/html/resources/js/pages/shipment/customers/index.vue'),
            /* no children */
          },
  _mergeRouteRecord(
          {
            path: 'identification-queue',
            name: 'shipment-customers-identification-queue',
            component: () => import('/var/www/html/resources/js/pages/shipment/customers/identification-queue.vue'),
            /* no children */
          },
  _definePage_default_14
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'inbox',
        name: 'shipment-inbox',
        component: () => import('/var/www/html/resources/js/pages/shipment/inbox.vue'),
        /* no children */
      },
  _definePage_default_15
  ),
      {
        path: 'incoming-parcels',
        /* internal name: 'shipment-incoming-parcels' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'shipment-incoming-parcels',
            component: () => import('/var/www/html/resources/js/pages/shipment/incoming-parcels/index.vue'),
            /* no children */
          },
  _definePage_default_16
  ),
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'shipment-incoming-parcels-id',
            component: () => import('/var/www/html/resources/js/pages/shipment/incoming-parcels/[id].vue'),
            /* no children */
          },
  _definePage_default_17
  )
        ],
      },
      {
        path: 'outgoing-packages',
        /* internal name: 'shipment-outgoing-packages' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'shipment-outgoing-packages',
            component: () => import('/var/www/html/resources/js/pages/shipment/outgoing-packages/index.vue'),
            /* no children */
          },
  _definePage_default_18
  )
        ],
      },
      {
        path: 'packing-lists',
        /* internal name: 'shipment-packing-lists' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'shipment-packing-lists',
            component: () => import('/var/www/html/resources/js/pages/shipment/packing-lists/index.vue'),
            /* no children */
          },
  _definePage_default_19
  ),
          {
            path: ':id',
            /* internal name: 'shipment-packing-lists-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'view',
                name: 'shipment-packing-lists-id-view',
                component: () => import('/var/www/html/resources/js/pages/shipment/packing-lists/[id]/view.vue'),
                /* no children */
              },
  _definePage_default_20
  )
            ],
          }
        ],
      },
      {
        path: 'partner-shipments',
        /* internal name: 'shipment-partner-shipments' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'shipment-partner-shipments',
            component: () => import('/var/www/html/resources/js/pages/shipment/partner-shipments/index.vue'),
            /* no children */
          },
  _definePage_default_21
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'pending-imports',
        name: 'shipment-pending-imports',
        component: () => import('/var/www/html/resources/js/pages/shipment/pending-imports.vue'),
        /* no children */
      },
  _definePage_default_22
  ),
      {
        path: 'products',
        /* internal name: 'shipment-products' */
        /* no component */
        children: [
          {
            path: '',
            name: 'shipment-products',
            component: () => import('/var/www/html/resources/js/pages/shipment/products/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            /* internal name: 'shipment-products-id' */
            /* no component */
            children: [
              {
                path: 'edit',
                name: 'shipment-products-id-edit',
                component: () => import('/var/www/html/resources/js/pages/shipment/products/[id]/edit.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'create',
            name: 'shipment-products-create',
            component: () => import('/var/www/html/resources/js/pages/shipment/products/create.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'settings',
        /* internal name: 'shipment-settings' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'shipment-settings',
            component: () => import('/var/www/html/resources/js/pages/shipment/settings/index.vue'),
            /* no children */
          },
  _definePage_default_23
  )
        ],
      },
      {
        path: 'warehouse',
        /* internal name: 'shipment-warehouse' */
        /* no component */
        children: [
          {
            path: 'arrange-parcels',
            /* internal name: 'shipment-warehouse-arrange-parcels' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':containerId',
                name: 'shipment-warehouse-arrange-parcels',
                component: () => import('/var/www/html/resources/js/pages/shipment/warehouse/arrange-parcels/[containerId].vue'),
                /* no children */
              },
  _definePage_default_24
  )
            ],
          },
          {
            path: 'client-groups',
            /* internal name: 'shipment-warehouse-client-groups' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':containerId',
                name: 'shipment-warehouse-client-groups',
                component: () => import('/var/www/html/resources/js/pages/shipment/warehouse/client-groups/[containerId].vue'),
                /* no children */
              },
  _definePage_default_25
  )
            ],
          },
          {
            path: 'cotation',
            /* internal name: 'shipment-warehouse-cotation' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'shipment-warehouse-cotation-index',
                component: () => import('/var/www/html/resources/js/pages/shipment/warehouse/cotation/index.vue'),
                /* no children */
              },
  _definePage_default_26
  ),
  _mergeRouteRecord(
              {
                path: ':containerId',
                name: 'shipment-warehouse-cotation',
                component: () => import('/var/www/html/resources/js/pages/shipment/warehouse/cotation/[containerId].vue'),
                /* no children */
              },
  _definePage_default_27
  )
            ],
          },
          {
            path: 'invoices',
            /* internal name: 'shipment-warehouse-invoices' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'shipment-warehouse-invoices',
                component: () => import('/var/www/html/resources/js/pages/shipment/warehouse/invoices/index.vue'),
                /* no children */
              },
  _definePage_default_28
  ),
  _mergeRouteRecord(
              {
                path: ':invoiceId',
                name: 'shipment-warehouse-invoices-view',
                component: () => import('/var/www/html/resources/js/pages/shipment/warehouse/invoices/[invoiceId].vue'),
                /* no children */
              },
  _definePage_default_29
  )
            ],
          },
          {
            path: 'pl-files',
            /* internal name: 'shipment-warehouse-pl-files' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'shipment-warehouse-pl-files-index',
                component: () => import('/var/www/html/resources/js/pages/shipment/warehouse/pl-files/index.vue'),
                /* no children */
              },
  _definePage_default_30
  ),
  _mergeRouteRecord(
              {
                path: ':containerId',
                name: 'shipment-warehouse-pl-files',
                component: () => import('/var/www/html/resources/js/pages/shipment/warehouse/pl-files/[containerId].vue'),
                /* no children */
              },
  _definePage_default_31
  )
            ],
          }
        ],
      }
    ],
  }
]
